import { Injector } from "@angular/core";
import { GridActionHandlerBase } from "../../../../../../components/common/grid-base/actions/grid-action-handler-base";
import { WorkspaceBase } from "../../../../../../components/common/workspace-base/workspace-base";

/**
 * Copies a Valuation Event
 */
export class CopyPortfolioGridActionHandler extends GridActionHandlerBase {
  /**
   * Constructor
   * @param injector Ihe Angular injector
   * @param workspace The workspace in which the action should be performed
   * @param topic Topic (subscribeEvent topic)
   */
  constructor(injector: Injector, workspace: WorkspaceBase) {
    super(injector, workspace, 'copyValuationPortfolioAssistant');
  }

  /**
  * Handles an event
  * @param _payload The (untyped) payload. Can also be a callback function
  */
  public handle(_payload: any): void {
    const selectedItem = this.workspace.grid.selectedItem;
    if (selectedItem) {
      this.eventBus.broadcastEvent('openCopyValuationPortfolioAssistant', selectedItem);
    }
    else {
      this.eventBus.broadcastEvent("openConfirmDialog", {
        success: () => {
          //Nothing
        }
      }, 'errorMessageChoosePortfolio');
    }
  }
}
